import {FC, useEffect, useState, useCallback, useMemo, useRef} from 'react';
import {Avatar, Colors, FInter, FlexBox, HintTooltip, Tooltip, useIsMobile, useToasts, useBreakpoint} from '@brg/ui'
import styled, { css, useTheme } from 'styled-components';
import {
    BlackFlatTooltip,
    DesignersLikesText,
    DesignersTooltipItem
} from '../../shared/components/projectDesignerName/styles';
import {API, Designer, LikeAPI, LikeEntity, LikeObject, Endpoints, QualityAPI, LikeStatisticsAPI, ProjectUtils} from '@brg/api';
import {bProfile, useProfile, useFingerprintId, ProfileUtils, ProfileRole} from '@brg/auth';
import i18next from 'i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LikeSolidIcon from '../../shared/assets/16/LikeSolidIcon';
import { IconWrapperSpecial } from 'shared/assets/styles';
import { LayoutConst } from './layout.module';
import LikesIcon32Fill from 'shared/assets/32/LikesIcon32Fill';
import LikesIcon32Empty from 'shared/assets/32/LikesIcon32Empty';
import { useDispatch, useSelector } from "react-redux";
import { CurrentProjectActions, CurrentProjectSelector } from "../../shared/reducers/CurrentProject";
import { AppTester } from 'supporting';
import InfiniteScroll from "react-infinite-scroll-component";
import { getTooltipStyles, tooptipStylesWhite } from 'shared/constants/tooptipStyles';
import { AVATAR_SIZES, FIXED_AVATAR_SIZE, getAvatarSizes } from 'shared/constants/AvatarSizes';
import { HsePolicies } from 'shared/constants/HsePolicies';

export interface LikesComponentProps {
    isLiked?: boolean;
    likes?: number;
    anonymousLikes?: number;
    onLikeClick?: () => void;
    size?: 'small' | 'medium';
    disabled?: boolean;
    hideCount?: boolean;
    items?: Designer[];
    itemsLikes?: [];
    onAccountClick?: (accountId: string) => void;
    onCountMove?: () => void;
    inActiveState?: boolean;
    hasMore?: boolean;
    getMore?: () => void;
    count?: number;
    tooltipProps?: any;
}

export interface LikeItem {
    designer: Designer;
    weight: number;
}

export const LikeIconWrapper = styled.div<{ isLiked?: boolean; disabled?: boolean }>`
  cursor: pointer;

  svg {
    fill: none;
  }

  :hover {
    svg {
      stroke: ${(p) => p.theme.likesController.hearthColor};
      fill: ${(p) => p.theme.likesController.hearthColor};
    }
  }

  :active {
    svg {
      stroke: ${(p) => p.theme.likesController.hearthColorLikes};
      fill: ${(p) => p.theme.likesController.hearthColorLikes};
    }
  }

  ${(p) =>
          p.isLiked
                  ? css`
                    svg {
                      stroke: ${(p) => p.theme.likesController.hearthColorLikes};
                      fill: ${(p) => p.theme.likesController.hearthColorLikes};
                    }

                    :hover {
                      svg {
                        stroke: ${(p) => p.theme.likesController.hearthColorLikes};
                        fill: ${(p) => p.theme.likesController.hearthColorLikes};
                      }
                    }

                    :active {
                      svg {
                        stroke: ${(p) => p.theme.likesController.hearthColor};
                        fill: none;
                      }
                    }
                  `
                  : null}

  ${(p) =>
          p.disabled
                  ? css`
                    svg {
                      stroke: ${(p) => p.theme.likesController.hearthColor} !important;
                      fill: none !important;
                    }

                    cursor: default;
                  `
                  : null}
`;

export const LikesCountText = styled(FInter.SmallText)`
  font-size: 13px;
  line-height: 16px;
  color: ${(p) => p.theme.icon.default};
  font-weight: 400;
  &:not(:first-child) {
    margin-left: 0;
  }
  margin-top: 4px;
    // @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    //     font-size: 11px;
    //     line-height: 13px;
    // }
    
    @media (max-width: 940px) {
        margin-top: 0;
        &:not(:first-child) {
            margin-left: 2px;
        }
    }
`;

export const DesignersTooltipContainer = styled(FlexBox)<{
    // подвязываемся именно по контексту, тема гео не должна быть на дезигне даже на темных проектах
    isGeo: boolean
}>`
    overflow-y: auto;
    max-height: ${(32 + 2) * 6}px;
    background: ${({isGeo}) => isGeo ? Colors.geoWhite10 : Colors.galBlack5};
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.08);
    border-radius: 3px;

  &::-webkit-scrollbar {
    width: 3px;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.08);
  }
  &::-webkit-scrollbar-thumb {
    background: ${({isGeo}) => isGeo ? Colors.geoWhite47 : Colors.galBlack47};
  }
  &::-webkit-scrollbar-track {
    background: ${({isGeo}) => isGeo ? Colors.geoWhite5 : Colors.galBlack10};
  }
  
  .likes-infinite-scroll {
    &::-webkit-scrollbar {
      width: 3px;
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.08);
    }
    &::-webkit-scrollbar-thumb {
      background: ${({isGeo}) => isGeo ? Colors.geoWhite47 : Colors.galBlack47};
    }
    &::-webkit-scrollbar-track {
      background: ${({isGeo}) => isGeo ? Colors.geoWhite5 : Colors.galBlack10};
    }
  }
`;

export const LikesTooltipItem = styled(DesignersTooltipItem)<{
    // подвязываемся именно по контексту, тема гео не должна быть на дезигне даже на темных проектах
    isGeo: boolean
}>`
    transition: background 0.2s;
    color: ${({isGeo}) => isGeo ? Colors.geoWhite100 : Colors.galBlack100} !important;
    padding: 2px 8px;
    &:hover {
        color: ${({isGeo}) => isGeo ? Colors.geoWhite100 : Colors.galBlack100} !important;
        text-decoration: none;
        background: ${({isGeo}) => isGeo ? Colors.geoWhite5 : Colors.galBlack10};
        > div {
            color: ${({isGeo}) => isGeo ? Colors.geoWhite100 : Colors.galBlack100} !important;
            text-decoration: none;
            background: ${({isGeo}) => isGeo ? Colors.geoWhite5 : Colors.galBlack10} !important;
        }
    }
  
    &:first-child {
      padding-top: 8px;
    }
    &:last-child {
      padding-bottom: 8px;
    }
`;

export const LikesBlackFlatTooltip = styled(BlackFlatTooltip)<{isMac13OrSmaller?: boolean}>`
    min-width: 400px;
  
    @media (max-width: ${LayoutConst.screen.mac13}px) {
      min-width: 316px;
    }
    
    :after {
      display: none;
    }
    ${({isMac13OrSmaller}) => isMac13OrSmaller && css`
        transform: translateX(20px);
        transform-origin: top right !important;
    `}
`;

export const LikesComponent: FC<LikesComponentProps> = ({
    isLiked,
    onLikeClick,
    size,
    disabled,
    tooltipProps,
}) => {
    const { t } = useTranslation()
    const theme = useTheme()
    const isSuperPuper = AppTester.isSuperPuper();
    const isGeo = AppTester.isGeograffee();
    const isGeoDafes = AppTester.isGeoDafes();
    const onWhiteBg = !isGeo && !isSuperPuper;

    if (size === 'small') {
        return (
            <IconWrapperSpecial onClick={onLikeClick} pressed={isLiked}>
                <HintTooltip
                    customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)}
                    text={t("hints.like")}
                    z={1000}
                    noDisappearDelay
                    onWhiteBg
                    {...tooltipProps}
                >
                    <LikeSolidIcon />
                </HintTooltip>
            </IconWrapperSpecial>
        );
    }

    return (
        <IconWrapperSpecial disabled={disabled} onClick={onLikeClick} pressed={isLiked}>
            <HintTooltip
                customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)}
                text={t("hints.like")}
                z={1000}
                noDisappearDelay
                onWhiteBg={onWhiteBg}
                {...tooltipProps}
            >
                {isLiked ? (
                    <LikesIcon32Fill fill={'auto'} />
                ) : (
                    <LikesIcon32Empty fill={'auto'} />
                )}
            </HintTooltip>
        </IconWrapperSpecial>
    );
};

export interface ProjectDesignersTooltipProps {
    target: JSX.Element;
    items: Designer[];
    itemsLikes: [];
    anonymousLikes: number;
    onSelect?: (identifier: string) => void;
    hasMore: boolean;
    getMore: () => void;
    count: number;
}

export const ProjectDesignersTooltip: FC<ProjectDesignersTooltipProps> = ({
    target,
    items,
    itemsLikes,
    anonymousLikes,
    onSelect = () => undefined,
    hasMore,
    getMore
}) => {

    const [currentLikes, setCurrentLikes] = useState<LikeItem[]>([]);
    const {t} = useTranslation();
    const isGeo = AppTester.isGeograffee()
    const [height, setHeight] = useState(0);
    const isMac13OrSmaller = useBreakpoint(LayoutConst.screen.mac13);
    const isTeamPage = !!useRouteMatch('/teams/:id');
    const onDesignerClick = (identifier: string) => () => onSelect(identifier);

    useEffect(() => {
        if (items && items.length !== 0 && itemsLikes && itemsLikes.length !== 0) {
            var sortedLikes = [...itemsLikes].sort((a: any, b: any) => {
                return a.weight < b.weight ? 1 : -1;
            });
            sortedLikes = [...sortedLikes].sort((a: any, b: any)=> {
                if (a.weight === b.weight){
                  return a.update < b.update ? 1 : -1
                } else {
                  return a.weight < b.weight ? 1 : -1
                }
            });

            var result: LikeItem[] = [];

            sortedLikes.forEach((element: any) => {
                const curDesigner = items.find(x => x.accountId === element?.accountId);

                if (curDesigner) {
                    result.push({
                        designer: curDesigner,
                        weight: element?.weight || 1
                    });
                }
            });

            setCurrentLikes(result);

        } else {
            setCurrentLikes([]);
        }
    }, [items, itemsLikes]);

    useEffect(() => {
       if (items && items.length) {
           items.forEach((designer) => {
               const avatar = bProfile.getAvatar(designer);
               if (avatar) {
                   const link = document.createElement('link');
                   link.setAttribute('rel', 'preload');
                   link.setAttribute('href', avatar);
                   link.setAttribute('as', 'image');
                   link.setAttribute('data-dropdown-preload', 'true');
                   document.head.append(link);
               }
           })
       }
        return () => {
            const links = document.querySelectorAll(`[data-dropdown-preload="true"]`)
            links.forEach((el) => {
                el.remove();
            })
        }
    }, [items])

    const anonymousLikeComponent = useMemo(() => {

        if (anonymousLikes <= 0) return null;

        return <LikesTooltipItem
            isGeo={isGeo}
            style={{cursor: 'auto'}}
            className="item"
            key={"anonymous"}
        >
            <FlexBox height={32} align={'center'} width={'100%'}>
                <FlexBox width={32} height={32}>
                    <Avatar name={"A"} surName={"N"} fs={11}/>
                </FlexBox>
                <DesignersLikesText offsetLeft={8} offsetRight={16}>
                    {t('anonymous_like')} {anonymousLikes > 1 && `[${anonymousLikes}]`}
                </DesignersLikesText>
            </FlexBox>
        </LikesTooltipItem>
    }, [anonymousLikes, isGeo])

    const loader = useMemo(() => {
        return (<LikesTooltipItem
                isGeo={isGeo}
                style={{cursor: 'auto'}}
                className="item"
                key={"anonymous"}
            >
                <FlexBox height={32} align={'center'} width={'100%'}>
                    <DesignersLikesText offsetLeft={8} offsetRight={16}>
                        {t('loading')}
                    </DesignersLikesText>
                </FlexBox>
            </LikesTooltipItem>)
    }, [isGeo]);

    const myRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const generalCount = (currentLikes?.length || 0) + (anonymousLikes > 0 ? 1 : 0);

        if (generalCount === 0 || generalCount === 1) {
            setHeight(48);
            return;
        }

        const generalHeight = generalCount * 36 + (generalCount > 1 ? 12 : 6);
        setHeight(generalHeight > 204 ? 204 : generalHeight < 48 ? 48 : generalHeight);
    }, [currentLikes, anonymousLikes]);

    return (
        <Tooltip target={target} placement={isMac13OrSmaller && isTeamPage ? 'bottom-end' : undefined}>
            <LikesBlackFlatTooltip isMac13OrSmaller={isMac13OrSmaller && isTeamPage}>
                <DesignersTooltipContainer
                  ref={myRef}
                  isGeo={isGeo}
                  direction={'column'}
                  width={'100%'}
                  onClick={(ev) => ev.stopPropagation()}
                  gy={2}
                  directionMobile="column"
                >
                    <InfiniteScroll
                        height={height}
                        dataLength={currentLikes?.length || 0}
                        next={getMore}
                        hasMore={hasMore}
                        initialScrollY={0}
                        scrollThreshold={0.8}
                        loader={loader}
                        endMessage={anonymousLikeComponent}
                        style={{display: 'flex', flexDirection: 'column'}}
                        className={'likes-infinite-scroll'}
                    >
                        {currentLikes.map((value) => (
                            <LikesTooltipItem
                                isGeo={isGeo}
                                className="item"
                                key={value.designer.accountId}
                                onClick={onDesignerClick(value.designer.accountId)}
                            >
                                <FlexBox height={32} align={'center'} width={'100%'}>
                                    <FlexBox width={32} height={32}>
                                        <Avatar 
                                            {...value.designer} 
                                            avatar={
                                                ProfileUtils.getAvatarURLOrUndefined(
                                                    value.designer, 
                                                    getAvatarSizes(AVATAR_SIZES.likes), 
                                                    // @ts-ignore
                                                    FIXED_AVATAR_SIZE)
                                            } 
                                            fs={11} 
                                            rounded 
                                        />
                                    </FlexBox>
                                    <DesignersLikesText offsetLeft={8} offsetRight={16}>
                                        {value.designer.name} {value.designer.surName} {value.weight > 1 ? `[${value.weight}]` : ''}
                                    </DesignersLikesText>
                                </FlexBox>
                            </LikesTooltipItem>
                        ))}
                    </InfiniteScroll>
                </DesignersTooltipContainer>
            </LikesBlackFlatTooltip>
        </Tooltip>
    );
};

export const LikesComponentWithPopup: FC<LikesComponentProps> = (props) => {
    const theme = useTheme();
    const isMobile = useIsMobile();

    const roundedLikes = useMemo(() => {

        if (!props?.likes) return 0;

        if (props?.likes < 1000) return props?.likes;

        const thousands = Math.floor(props?.likes / 1000)
        const hundreds = Math.floor(props?.likes % 1000 / 100)

        if (!hundreds) return `${thousands}к`
        return `${thousands}.${hundreds}к`

    }, [props?.likes])

    return (
        <FlexBox
            align={'center'}
            justify={"flex-start"}
            direction={'column'}
            directionMobile={'row'}
            gx={props.size === 'small' ? 6 : 8}
            offsetBottomMobile={0}
            className={'likes-icon-wrapper'}
        >

            {!props.hideCount &&
            (((props.likes && props.likes > 0 && props.items && props.items.length > 0) || (props?.anonymousLikes || 0) > 0) && !isMobile ? (
                <ProjectDesignersTooltip
                    target={
                        <FlexBox direction="column" align="center" className={'likes-icon-wrapper'}>
                          <LikesComponent {...props} />
                          <LikesCountText
                              onMouseEnter={props.inActiveState ? () => false : props.onCountMove}
                              color={theme.likesController.text}
                          >
                              {roundedLikes ?? 0}
                          </LikesCountText>
                        </FlexBox>
                    }
                    hasMore={props?.hasMore || false}
                    getMore={props?.getMore || (() => {})}
                    count={props?.count || 1}
                    anonymousLikes={props?.anonymousLikes || 0}
                    items={props.items ? props.items : []}
                    itemsLikes={props.itemsLikes ? props.itemsLikes : []}
                    onSelect={props.onAccountClick}
                />
            ) : (
                <>
                  <LikesComponent {...props} />
                  <LikesCountText
                      className={'likes-count-text'}
                      color={theme.likesController.text}>
                      {roundedLikes ?? 0}
                  </LikesCountText>
                </>
            ))}
        </FlexBox>
    );
};

export const LikesController: FC<LikesComponentProps & LikeEntity> = (props) => {
    const {t} = useTranslation();
    const {entityId, entityType, inActiveState} = props;
    const history = useHistory();
    const toasts = useToasts();
    const dispatch = useDispatch();
    const profile = useProfile();
    const fingerprintId = useFingerprintId();

    const [isLoading, setIsLoading] = useState(false);

    const isLiked = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.isLiked;
    const likes = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.likes;
    const anonymousLikes = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.anonymousLikes;
    const items = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.items || [];
    const itemsLikes = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.itemsLikes || [];
    const isNoLikes = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.isNoLikes;
    const paging = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.itemsLikesPaging;
    const likeWeightByEntityId = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.likeWeight || 1;

    const hasLikeWeightPolicy = useMemo(() => profile && profile.rolesList && Array.isArray(profile.rolesList)
        && profile.rolesList.some(x => x.startsWith(HsePolicies.like_value_prefix))
    , [profile]);

    const getLikeWeightFromPolicy = () => {
        if (!profile || !profile.rolesList || !hasLikeWeightPolicy) {
            return 1;
        }

        const policyLikeWeight = profile.rolesList
            .filter(x => x.startsWith(HsePolicies.like_value_prefix))
            .map(x => x.replace(HsePolicies.like_value_prefix, ''))
            .map(x =>  Number.isInteger(Number.parseInt(x)) ? Number.parseInt(x) : 0);
        return Math.max(1, ...policyLikeWeight);            
    }   

    const likeWeight = hasLikeWeightPolicy ? getLikeWeightFromPolicy() : likeWeightByEntityId;

    const setLikeWeight = (id: string, value?: number) => {
        dispatch(CurrentProjectActions.setLikesField({id, field: 'likeWeight', value }))
    }

    const setIsLiked = (id: string, value?: boolean) => {
        dispatch(CurrentProjectActions.setLikesField({id, field: 'isLiked', value }))
    }

    const setItems = (id: string, value: any) => {
        dispatch(CurrentProjectActions.setLikesField({id, field: 'items', value }))
    }

    const setItemsLikes = (id: string, value: any) => {
        dispatch(CurrentProjectActions.setLikesField({id, field: 'itemsLikes', value }))
    }

    const setItemsLikesPaging = (id: string, value: any) => {
        dispatch(CurrentProjectActions.setLikesField({id, field: 'itemsLikesPaging', value }))
    }

    const setIsNoLikes = (id: string, value: any) => {
        dispatch(CurrentProjectActions.setLikesField({id, field: 'isNoLikes', value }))
    }

    const setLikes = (id: string, value: any) => {
        dispatch(CurrentProjectActions.setLikesField({id, field: 'likes', value }))
    }

    const setAnonymousLikes = (id: string, value: any) => {
        dispatch(CurrentProjectActions.setLikesField({id, field: 'anonymousLikes', value }))
    }

    const getDesignersByIds = useCallback((ids: string[], isAdd?: boolean) => {

        if (ids?.length) {
            API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/Designer/GetCollection')
                .get()
                .addQuery('idDesignerList', ids)
                .send()
                .then((b) => b.json())
                .then((b) => API.toLang<Designer[]>(b, i18next.language))
                .then((b: Designer[]) => {
                    setItems(entityId, isAdd ? [...items, ...b] : b)
                });
        } else {
            setItems(entityId, [])
        }
    }, [entityId, items]);

    const GetAccountIdsByPage = useCallback((currentPage: number) => {

        LikeAPI.GetAccountIdsOfEntityLikes(
            {entityId: entityId, entityType: entityType, limit: 50, page: currentPage})
            .then((v: any) => v.json())
            .then((v: any) => {
                setItemsLikes(entityId, currentPage > 1 ? [...itemsLikes, ...(v?.data || [])] : v?.data || []);
                if (v?.paging) setItemsLikesPaging(entityId, v?.paging);
                getDesignersByIds(v?.data?.map((item: any) => item?.accountId) || [], currentPage > 1)
                setIsLoading(false);
            })
            .catch((reason) => {
                console.error(reason);
                setIsLoading(false);
            });
    }, [entityId, entityType, itemsLikes, getDesignersByIds]);

    const GetLikeWeight = useCallback(() => {
        if (!profile?.accountId) {
            setLikeWeight(entityId, 1);
            return;
        }

        if (hasLikeWeightPolicy) {
            var policyLikeWeight = getLikeWeightFromPolicy();
            setLikeWeight(entityId, policyLikeWeight);
            return policyLikeWeight;
        }

        setIsLoading(true)
        QualityAPI.GetWeight({accountId: profile?.accountId || ''})
            .then(r => r.json())
            .then(r => {
                setLikeWeight(entityId, r?.baseWeight);
                setIsLoading(false);
            })
            .catch((reason) => {
                console.error(reason);
                setIsLoading(false);
            });
    }, [profile?.accountId, hasLikeWeightPolicy, entityId])

    const GetMoreAccountIds = useCallback(() => {
        GetAccountIdsByPage(paging?.page + 1)
    }, [GetAccountIdsByPage, paging]);

    const GetLikeStatistics = useCallback(() => {
        setIsLoading(true);
        LikeStatisticsAPI.GetLikeStatistics(
            {entityId: entityId, entityType: entityType})
            .then((v: any) => v.json())
            .then((v: any) => {
                if (v?.userLike?.accountId) {
                    setIsLiked(v?.entity?.entityId, v?.userLike?.isLike);
                }
                setLikes(v?.entity?.entityId, v?.count);
                setAnonymousLikes(v?.entity?.entityId, v?.notAuthLikesCount);
                setIsLoading(false);
            })
            .catch((reason) => {
                console.error(reason);
                setIsLoading(false);
            });
    }, [entityId, entityType]);

    useEffect(() => {
        // обязательно должен быть фингерпринт, чтобы запрос обработался(сам он находится в заголовках)
        if (fingerprintId && entityType && entityId) {
            GetAccountIdsByPage(1)
            GetLikeStatistics()
        }
    }, [entityId, entityType, fingerprintId])

    useEffect(() => {
        if (fingerprintId && entityType && entityId) {
            GetLikeWeight()
        }
    }, [entityId, entityType, fingerprintId, GetLikeWeight])

    const onLikeClick = () => {
        if (isLoading || inActiveState) {
            return;
        }

        if (!profile?.accountId) {
            toasts.error(t('main_admin_tag.error.auth_error'));  
            return;
          }

        setIsLiked(entityId, !Boolean(isLiked));
        setLikes(
            entityId, 
            isLiked
                ? (likes || likeWeight) - likeWeight
                : (likes || 0) + likeWeight);

        if (!profile?.accountId) {
            setAnonymousLikes(
                entityId,
                isLiked
                    ? (anonymousLikes || 1) - 1
                    : (anonymousLikes || 0) + 1);
        }
        setIsLoading(true);
        LikeAPI.LikeV2({entityId: props.entityId, entityType: props.entityType})
            .then((value: any) => value.json())
            .then((v: any) => {
                if (v === "Max limit") {
                    toasts.error(t('like_limit_info'));
                    setIsLiked(entityId, false)
                    setLikes(entityId, (likes || 1))
                    return "";
                }
                else {
                    return API.toLang<LikeObject>(v, i18next.language)
                }
            })
            .then((v: any) => {
                if (v !== "") {
                    GetLikeStatistics();
                }
                GetAccountIdsByPage(1)
                setIsLoading(false);
            })
            .catch((reason) => {
                console.error(reason);
                setIsLoading(false);
            });
    };

    return (
      <LikesComponentWithPopup
        onLikeClick={onLikeClick}
        onAccountClick={(accountId) => history.push('/designer/' + accountId)}
        hasMore={paging?.page < (paging?.pages)}
        count={paging?.count ?? 0}
        getMore={GetMoreAccountIds}
        items={inActiveState ? [] : items}
        itemsLikes={itemsLikes}
        likes={likes}
        anonymousLikes={inActiveState ? 0 : anonymousLikes}
        isLiked={isLiked}
        tooltipProps={props.tooltipProps}
      />
    );
};
import {FC, useEffect, useState, useCallback, useMemo, useRef} from 'react';
import {Avatar, Colors, FInter, FlexBox, HintTooltip, Tooltip, useIsMobile, useToasts, useBreakpoint} from '@brg/ui'
import styled, { css, useTheme } from 'styled-components';
import {
    BlackFlatTooltip,
    DesignersLikesText,
    DesignersTooltipItem
} from '../../shared/components/projectDesignerName/styles';
import {API, Designer, LikeAPI, LikeEntity, LikeObject, Endpoints, QualityAPI, LikeStatisticsAPI, ProjectUtils} from '@brg/api';
import {bProfile, useProfile, useFingerprintId, ProfileUtils, ProfileRole} from '@brg/auth';
import i18next from 'i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LikeSolidIcon from '../../shared/assets/16/LikeSolidIcon';
import { IconWrapperSpecial } from 'shared/assets/styles';
import { LayoutConst } from './layout.module';
import LikesIcon32Fill from 'shared/assets/32/LikesIcon32Fill';
import LikesIcon32Empty from 'shared/assets/32/LikesIcon32Empty';
import { useDispatch, useSelector } from "react-redux";
import { CurrentProjectActions, CurrentProjectSelector } from "../../shared/reducers/CurrentProject";
import { AppTester } from 'supporting';
import InfiniteScroll from "react-infinite-scroll-component";
import { getTooltipStyles, tooptipStylesWhite } from 'shared/constants/tooptipStyles';
import { AVATAR_SIZES, FIXED_AVATAR_SIZE, getAvatarSizes } from 'shared/constants/AvatarSizes';
import { HsePolicies } from 'shared/constants/HsePolicies';

export interface LikesComponentProps {
    isLiked?: boolean;
    likes?: number;
    anonymousLikes?: number;
    onLikeClick?: () => void;
    size?: 'small' | 'medium';
    disabled?: boolean;
    hideCount?: boolean;
    items?: Designer[];
    itemsLikes?: [];
    onAccountClick?: (accountId: string) => void;
    onCountMove?: () => void;
    inActiveState?: boolean;
    hasMore?: boolean;
    getMore?: () => void;
    count?: number;
    tooltipProps?: any;
}

export interface LikeItem {
    designer: Designer;
    weight: number;
}

export const LikeIconWrapper = styled.div<{ isLiked?: boolean; disabled?: boolean }>`
  cursor: pointer;

  svg {
    fill: none;
  }

  :hover {
    svg {
      stroke: ${(p) => p.theme.likesController.hearthColor};
      fill: ${(p) => p.theme.likesController.hearthColor};
    }
  }

  :active {
    svg {
      stroke: ${(p) => p.theme.likesController.hearthColorLikes};
      fill: ${(p) => p.theme.likesController.hearthColorLikes};
    }
  }

  ${(p) =>
          p.isLiked
                  ? css`
                    svg {
                      stroke: ${(p) => p.theme.likesController.hearthColorLikes};
                      fill: ${(p) => p.theme.likesController.hearthColorLikes};
                    }

                    :hover {
                      svg {
                        stroke: ${(p) => p.theme.likesController.hearthColorLikes};
                        fill: ${(p) => p.theme.likesController.hearthColorLikes};
                      }
                    }

                    :active {
                      svg {
                        stroke: ${(p) => p.theme.likesController.hearthColor};
                        fill: none;
                      }
                    }
                  `
                  : null}

  ${(p) =>
          p.disabled
                  ? css`
                    svg {
                      stroke: ${(p) => p.theme.likesController.hearthColor} !important;
                      fill: none !important;
                    }

                    cursor: default;
                  `
                  : null}
`;

export const LikesCountText = styled(FInter.SmallText)`
  font-size: 13px;
  line-height: 16px;
  color: ${(p) => p.theme.icon.default};
  font-weight: 400;
  &:not(:first-child) {
    margin-left: 0;
  }
  margin-top: 4px;
    // @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    //     font-size: 11px;
    //     line-height: 13px;
    // }
    
    @media (max-width: 940px) {
        margin-top: 0;
        &:not(:first-child) {
            margin-left: 2px;
        }
    }
`;

export const DesignersTooltipContainer = styled(FlexBox)<{
    // подвязываемся именно по контексту, тема гео не должна быть на дезигне даже на темных проектах
    isGeo: boolean
}>`
    overflow-y: auto;
    max-height: ${(32 + 2) * 6}px;
    background: ${({isGeo}) => isGeo ? Colors.geoWhite10 : Colors.galBlack5};
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.08);
    border-radius: 3px;

  &::-webkit-scrollbar {
    width: 3px;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.08);
  }
  &::-webkit-scrollbar-thumb {
    background: ${({isGeo}) => isGeo ? Colors.geoWhite47 : Colors.galBlack47};
  }
  &::-webkit-scrollbar-track {
    background: ${({isGeo}) => isGeo ? Colors.geoWhite5 : Colors.galBlack10};
  }
  
  .likes-infinite-scroll {
    &::-webkit-scrollbar {
      width: 3px;
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.08);
    }
    &::-webkit-scrollbar-thumb {
      background: ${({isGeo}) => isGeo ? Colors.geoWhite47 : Colors.galBlack47};
    }
    &::-webkit-scrollbar-track {
      background: ${({isGeo}) => isGeo ? Colors.geoWhite5 : Colors.galBlack10};
    }
  }
`;

export const LikesTooltipItem = styled(DesignersTooltipItem)<{
    // подвязываемся именно по контексту, тема гео не должна быть на дезигне даже на темных проектах
    isGeo: boolean
}>`
    transition: background 0.2s;
    color: ${({isGeo}) => isGeo ? Colors.geoWhite100 : Colors.galBlack100} !important;
    padding: 2px 8px;
    &:hover {
        color: ${({isGeo}) => isGeo ? Colors.geoWhite100 : Colors.galBlack100} !important;
        text-decoration: none;
        background: ${({isGeo}) => isGeo ? Colors.geoWhite5 : Colors.galBlack10};
        > div {
            color: ${({isGeo}) => isGeo ? Colors.geoWhite100 : Colors.galBlack100} !important;
            text-decoration: none;
            background: ${({isGeo}) => isGeo ? Colors.geoWhite5 : Colors.galBlack10} !important;
        }
    }
  
    &:first-child {
      padding-top: 8px;
    }
    &:last-child {
      padding-bottom: 8px;
    }
`;

export const LikesBlackFlatTooltip = styled(BlackFlatTooltip)<{isMac13OrSmaller?: boolean}>`
    min-width: 400px;
  
    @media (max-width: ${LayoutConst.screen.mac13}px) {
      min-width: 316px;
    }
    
    :after {
      display: none;
    }
    ${({isMac13OrSmaller}) => isMac13OrSmaller && css`
        transform: translateX(20px);
        transform-origin: top right !important;
    `}
`;

export const LikesComponent: FC<LikesComponentProps> = ({
    isLiked,
    onLikeClick,
    size,
    disabled,
    tooltipProps,
}) => {
    const { t } = useTranslation()
    const theme = useTheme()
    const isSuperPuper = AppTester.isSuperPuper();
    const isGeo = AppTester.isGeograffee();
    const isGeoDafes = AppTester.isGeoDafes();
    const onWhiteBg = !isGeo && !isSuperPuper;

    if (size === 'small') {
        return (
            <IconWrapperSpecial onClick={onLikeClick} pressed={isLiked}>
                <HintTooltip
                    customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)}
                    text={t("hints.like")}
                    z={1000}
                    noDisappearDelay
                    onWhiteBg
                    {...tooltipProps}
                >
                    <LikeSolidIcon />
                </HintTooltip>
            </IconWrapperSpecial>
        );
    }

    return (
        <IconWrapperSpecial disabled={disabled} onClick={onLikeClick} pressed={isLiked}>
            <HintTooltip
                customStyle={isGeoDafes || onWhiteBg ? tooptipStylesWhite : getTooltipStyles(theme)}
                text={t("hints.like")}
                z={1000}
                noDisappearDelay
                onWhiteBg={onWhiteBg}
                {...tooltipProps}
            >
                {isLiked ? (
                    <LikesIcon32Fill fill={'auto'} />
                ) : (
                    <LikesIcon32Empty fill={'auto'} />
                )}
            </HintTooltip>
        </IconWrapperSpecial>
    );
};

export interface ProjectDesignersTooltipProps {
    target: JSX.Element;
    items: Designer[];
    itemsLikes: [];
    anonymousLikes: number;
    onSelect?: (identifier: string) => void;
    hasMore: boolean;
    getMore: () => void;
    count: number;
}

export const ProjectDesignersTooltip: FC<ProjectDesignersTooltipProps> = ({
    target,
    items,
    itemsLikes,
    anonymousLikes,
    onSelect = () => undefined,
    hasMore,
    getMore
}) => {

    const [currentLikes, setCurrentLikes] = useState<LikeItem[]>([]);
    const {t} = useTranslation();
    const isGeo = AppTester.isGeograffee()
    const [height, setHeight] = useState(0);
    const isMac13OrSmaller = useBreakpoint(LayoutConst.screen.mac13);
    const isTeamPage = !!useRouteMatch('/teams/:id');
    const onDesignerClick = (identifier: string) => () => onSelect(identifier);

    useEffect(() => {
        if (items && items.length !== 0 && itemsLikes && itemsLikes.length !== 0) {
            var sortedLikes = [...itemsLikes].sort((a: any, b: any) => {
                return a.weight < b.weight ? 1 : -1;
            });
            sortedLikes = [...sortedLikes].sort((a: any, b: any)=> {
                if (a.weight === b.weight){
                  return a.update < b.update ? 1 : -1
                } else {
                  return a.weight < b.weight ? 1 : -1
                }
            });

            var result: LikeItem[] = [];

            sortedLikes.forEach((element: any) => {
                const curDesigner = items.find(x => x.accountId === element?.accountId);

                if (curDesigner) {
                    result.push({
                        designer: curDesigner,
                        weight: element?.weight || 1
                    });
                }
            });

            setCurrentLikes(result);

        } else {
            setCurrentLikes([]);
        }
    }, [items, itemsLikes]);

    useEffect(() => {
       if (items && items.length) {
           items.forEach((designer) => {
               const avatar = bProfile.getAvatar(designer);
               if (avatar) {
                   const link = document.createElement('link');
                   link.setAttribute('rel', 'preload');
                   link.setAttribute('href', avatar);
                   link.setAttribute('as', 'image');
                   link.setAttribute('data-dropdown-preload', 'true');
                   document.head.append(link);
               }
           })
       }
        return () => {
            const links = document.querySelectorAll(`[data-dropdown-preload="true"]`)
            links.forEach((el) => {
                el.remove();
            })
        }
    }, [items])

    const anonymousLikeComponent = useMemo(() => {

        if (anonymousLikes <= 0) return null;

        return <LikesTooltipItem
            isGeo={isGeo}
            style={{cursor: 'auto'}}
            className="item"
            key={"anonymous"}
        >
            <FlexBox height={32} align={'center'} width={'100%'}>
                <FlexBox width={32} height={32}>
                    <Avatar name={"A"} surName={"N"} fs={11}/>
                </FlexBox>
                <DesignersLikesText offsetLeft={8} offsetRight={16}>
                    {t('anonymous_like')} {anonymousLikes > 1 && `[${anonymousLikes}]`}
                </DesignersLikesText>
            </FlexBox>
        </LikesTooltipItem>
    }, [anonymousLikes, isGeo])

    const loader = useMemo(() => {
        return (<LikesTooltipItem
                isGeo={isGeo}
                style={{cursor: 'auto'}}
                className="item"
                key={"anonymous"}
            >
                <FlexBox height={32} align={'center'} width={'100%'}>
                    <DesignersLikesText offsetLeft={8} offsetRight={16}>
                        {t('loading')}
                    </DesignersLikesText>
                </FlexBox>
            </LikesTooltipItem>)
    }, [isGeo]);

    const myRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const generalCount = (currentLikes?.length || 0) + (anonymousLikes > 0 ? 1 : 0);

        if (generalCount === 0 || generalCount === 1) {
            setHeight(48);
            return;
        }

        const generalHeight = generalCount * 36 + (generalCount > 1 ? 12 : 6);
        setHeight(generalHeight > 204 ? 204 : generalHeight < 48 ? 48 : generalHeight);
    }, [currentLikes, anonymousLikes]);

    return (
        <Tooltip target={target} placement={isMac13OrSmaller && isTeamPage ? 'bottom-end' : undefined}>
            <LikesBlackFlatTooltip isMac13OrSmaller={isMac13OrSmaller && isTeamPage}>
                <DesignersTooltipContainer
                  ref={myRef}
                  isGeo={isGeo}
                  direction={'column'}
                  width={'100%'}
                  onClick={(ev) => ev.stopPropagation()}
                  gy={2}
                  directionMobile="column"
                >
                    <InfiniteScroll
                        height={height}
                        dataLength={currentLikes?.length || 0}
                        next={getMore}
                        hasMore={hasMore}
                        initialScrollY={0}
                        scrollThreshold={0.8}
                        loader={loader}
                        endMessage={anonymousLikeComponent}
                        style={{display: 'flex', flexDirection: 'column'}}
                        className={'likes-infinite-scroll'}
                    >
                        {currentLikes.map((value) => (
                            <LikesTooltipItem
                                isGeo={isGeo}
                                className="item"
                                key={value.designer.accountId}
                                onClick={onDesignerClick(value.designer.accountId)}
                            >
                                <FlexBox height={32} align={'center'} width={'100%'}>
                                    <FlexBox width={32} height={32}>
                                        <Avatar 
                                            {...value.designer} 
                                            avatar={
                                                ProfileUtils.getAvatarURLOrUndefined(
                                                    value.designer, 
                                                    getAvatarSizes(AVATAR_SIZES.likes), 
                                                    // @ts-ignore
                                                    FIXED_AVATAR_SIZE)
                                            } 
                                            fs={11} 
                                            rounded 
                                        />
                                    </FlexBox>
                                    <DesignersLikesText offsetLeft={8} offsetRight={16}>
                                        {value.designer.name} {value.designer.surName} {value.weight > 1 ? `[${value.weight}]` : ''}
                                    </DesignersLikesText>
                                </FlexBox>
                            </LikesTooltipItem>
                        ))}
                    </InfiniteScroll>
                </DesignersTooltipContainer>
            </LikesBlackFlatTooltip>
        </Tooltip>
    );
};

export const LikesComponentWithPopup: FC<LikesComponentProps> = (props) => {
    const theme = useTheme();
    const isMobile = useIsMobile();

    const roundedLikes = useMemo(() => {

        if (!props?.likes) return 0;

        if (props?.likes < 1000) return props?.likes;

        const thousands = Math.floor(props?.likes / 1000)
        const hundreds = Math.floor(props?.likes % 1000 / 100)

        if (!hundreds) return `${thousands}к`
        return `${thousands}.${hundreds}к`

    }, [props?.likes])

    return (
        <FlexBox
            align={'center'}
            justify={"flex-start"}
            direction={'column'}
            directionMobile={'row'}
            gx={props.size === 'small' ? 6 : 8}
            offsetBottomMobile={0}
            className={'likes-icon-wrapper'}
        >

            {!props.hideCount &&
            (((props.likes && props.likes > 0 && props.items && props.items.length > 0) || (props?.anonymousLikes || 0) > 0) && !isMobile ? (
                <ProjectDesignersTooltip
                    target={
                        <FlexBox direction="column" align="center" className={'likes-icon-wrapper'}>
                          <LikesComponent {...props} />
                          <LikesCountText
                              onMouseEnter={props.inActiveState ? () => false : props.onCountMove}
                              color={theme.likesController.text}
                          >
                              {roundedLikes ?? 0}
                          </LikesCountText>
                        </FlexBox>
                    }
                    hasMore={props?.hasMore || false}
                    getMore={props?.getMore || (() => {})}
                    count={props?.count || 1}
                    anonymousLikes={props?.anonymousLikes || 0}
                    items={props.items ? props.items : []}
                    itemsLikes={props.itemsLikes ? props.itemsLikes : []}
                    onSelect={props.onAccountClick}
                />
            ) : (
                <>
                  <LikesComponent {...props} />
                  <LikesCountText
                      className={'likes-count-text'}
                      color={theme.likesController.text}>
                      {roundedLikes ?? 0}
                  </LikesCountText>
                </>
            ))}
        </FlexBox>
    );
};

export const LikesController: FC<LikesComponentProps & LikeEntity> = (props) => {
    const {t} = useTranslation();
    const {entityId, entityType, inActiveState} = props;
    const history = useHistory();
    const toasts = useToasts();
    const dispatch = useDispatch();
    const profile = useProfile();
    const fingerprintId = useFingerprintId();

    const [isLoading, setIsLoading] = useState(false);

    const isLiked = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.isLiked;
    const likes = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.likes;
    const anonymousLikes = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.anonymousLikes;
    const items = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.items || [];
    const itemsLikes = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.itemsLikes || [];
    const isNoLikes = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.isNoLikes;
    const paging = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.itemsLikesPaging;
    const likeWeightByEntityId = useSelector(CurrentProjectSelector)?.likes?.[entityId]?.likeWeight || 1;

    const hasLikeWeightPolicy = useMemo(() => profile && profile.rolesList && Array.isArray(profile.rolesList)
        && profile.rolesList.some(x => x.startsWith(HsePolicies.like_value_prefix))
    , [profile]);

    const getLikeWeightFromPolicy = () => {
        if (!profile || !profile.rolesList || !hasLikeWeightPolicy) {
            return 1;
        }

        const policyLikeWeight = profile.rolesList
            .filter(x => x.startsWith(HsePolicies.like_value_prefix))
            .map(x => x.replace(HsePolicies.like_value_prefix, ''))
            .map(x =>  Number.isInteger(Number.parseInt(x)) ? Number.parseInt(x) : 0);
        return Math.max(1, ...policyLikeWeight);            
    }   

    const likeWeight = hasLikeWeightPolicy ? getLikeWeightFromPolicy() : likeWeightByEntityId;

    const setLikeWeight = (id: string, value?: number) => {
        dispatch(CurrentProjectActions.setLikesField({id, field: 'likeWeight', value }))
    }

    const setIsLiked = (id: string, value?: boolean) => {
        dispatch(CurrentProjectActions.setLikesField({id, field: 'isLiked', value }))
    }

    const setItems = (id: string, value: any) => {
        dispatch(CurrentProjectActions.setLikesField({id, field: 'items', value }))
    }

    const setItemsLikes = (id: string, value: any) => {
        dispatch(CurrentProjectActions.setLikesField({id, field: 'itemsLikes', value }))
    }

    const setItemsLikesPaging = (id: string, value: any) => {
        dispatch(CurrentProjectActions.setLikesField({id, field: 'itemsLikesPaging', value }))
    }

    const setIsNoLikes = (id: string, value: any) => {
        dispatch(CurrentProjectActions.setLikesField({id, field: 'isNoLikes', value }))
    }

    const setLikes = (id: string, value: any) => {
        dispatch(CurrentProjectActions.setLikesField({id, field: 'likes', value }))
    }

    const setAnonymousLikes = (id: string, value: any) => {
        dispatch(CurrentProjectActions.setLikesField({id, field: 'anonymousLikes', value }))
    }

    const getDesignersByIds = useCallback((ids: string[], isAdd?: boolean) => {

        if (ids?.length) {
            API.request()
                .endpoint(Endpoints.geograffee)
                .url('/api/Designer/GetCollection')
                .get()
                .addQuery('idDesignerList', ids)
                .send()
                .then((b) => b.json())
                .then((b) => API.toLang<Designer[]>(b, i18next.language))
                .then((b: Designer[]) => {
                    setItems(entityId, isAdd ? [...items, ...b] : b)
                });
        } else {
            setItems(entityId, [])
        }
    }, [entityId, items]);

    const GetAccountIdsByPage = useCallback((currentPage: number) => {

        LikeAPI.GetAccountIdsOfEntityLikes(
            {entityId: entityId, entityType: entityType, limit: 50, page: currentPage})
            .then((v: any) => v.json())
            .then((v: any) => {
                setItemsLikes(entityId, currentPage > 1 ? [...itemsLikes, ...(v?.data || [])] : v?.data || []);
                if (v?.paging) setItemsLikesPaging(entityId, v?.paging);
                getDesignersByIds(v?.data?.map((item: any) => item?.accountId) || [], currentPage > 1)
                setIsLoading(false);
            })
            .catch((reason) => {
                console.error(reason);
                setIsLoading(false);
            });
    }, [entityId, entityType, itemsLikes, getDesignersByIds]);

    const GetLikeWeight = useCallback(() => {
        if (!profile?.accountId) {
            setLikeWeight(entityId, 1);
            return;
        }

        if (hasLikeWeightPolicy) {
            var policyLikeWeight = getLikeWeightFromPolicy();
            setLikeWeight(entityId, policyLikeWeight);
            return policyLikeWeight;
        }

        setIsLoading(true)
        QualityAPI.GetWeight({accountId: profile?.accountId || ''})
            .then(r => r.json())
            .then(r => {
                setLikeWeight(entityId, r?.baseWeight);
                setIsLoading(false);
            })
            .catch((reason) => {
                console.error(reason);
                setIsLoading(false);
            });
    }, [profile?.accountId, hasLikeWeightPolicy, entityId])

    const GetMoreAccountIds = useCallback(() => {
        GetAccountIdsByPage(paging?.page + 1)
    }, [GetAccountIdsByPage, paging]);

    const GetLikeStatistics = useCallback(() => {
        setIsLoading(true);
        LikeStatisticsAPI.GetLikeStatistics(
            {entityId: entityId, entityType: entityType})
            .then((v: any) => v.json())
            .then((v: any) => {
                if (v?.userLike?.accountId) {
                    setIsLiked(v?.entity?.entityId, v?.userLike?.isLike);
                }
                setLikes(v?.entity?.entityId, v?.count);
                setAnonymousLikes(v?.entity?.entityId, v?.notAuthLikesCount);
                setIsLoading(false);
            })
            .catch((reason) => {
                console.error(reason);
                setIsLoading(false);
            });
    }, [entityId, entityType]);

    useEffect(() => {
        // обязательно должен быть фингерпринт, чтобы запрос обработался(сам он находится в заголовках)
        if (fingerprintId && entityType && entityId) {
            GetAccountIdsByPage(1)
            GetLikeStatistics()
        }
    }, [entityId, entityType, fingerprintId])

    useEffect(() => {
        if (fingerprintId && entityType && entityId) {
            GetLikeWeight()
        }
    }, [entityId, entityType, fingerprintId, GetLikeWeight])

    const onLikeClick = () => {
        if (isLoading || inActiveState) {
            return;
        }

        if (!profile?.accountId) {
            toasts.error(t('main_admin_tag.error.auth_error'));  
            return;
          }

        setIsLiked(entityId, !Boolean(isLiked));
        setLikes(
            entityId, 
            isLiked
                ? (likes || likeWeight) - likeWeight
                : (likes || 0) + likeWeight);

        if (!profile?.accountId) {
            setAnonymousLikes(
                entityId,
                isLiked
                    ? (anonymousLikes || 1) - 1
                    : (anonymousLikes || 0) + 1);
        }
        setIsLoading(true);
        LikeAPI.LikeV2({entityId: props.entityId, entityType: props.entityType})
            .then((value: any) => value.json())
            .then((v: any) => {
                if (v === "Max limit") {
                    toasts.error(t('like_limit_info'));
                    setIsLiked(entityId, false)
                    setLikes(entityId, (likes || 1))
                    return "";
                }
                else {
                    return API.toLang<LikeObject>(v, i18next.language)
                }
            })
            .then((v: any) => {
                if (v !== "") {
                    GetLikeStatistics();
                }
                GetAccountIdsByPage(1)
                setIsLoading(false);
            })
            .catch((reason) => {
                console.error(reason);
                setIsLoading(false);
            });
    };

    return (
      <LikesComponentWithPopup
        onLikeClick={onLikeClick}
        onAccountClick={(accountId) => history.push('/designer/' + accountId)}
        hasMore={paging?.page < (paging?.pages)}
        count={paging?.count ?? 0}
        getMore={GetMoreAccountIds}
        items={inActiveState ? [] : items}
        itemsLikes={itemsLikes}
        likes={likes}
        anonymousLikes={inActiveState ? 0 : anonymousLikes}
        isLiked={isLiked}
        tooltipProps={props.tooltipProps}
      />
    );
};
